
import { takeEvery } from 'redux-saga/effects'

export const CLEAR = 'map/CLEAR';
export const CHANGE_VIEW = 'map/CHANGE_VIEW';
export const INIT_PROJECT = 'map/INIT_PROJECT';
export const SET_LAYER_VISIBILITY = 'map/SET_LAYER_VISIBILITY';
export const RESET = 'map/RESET';

export const ADD_COMMAND = 'map/ADD_COMMAND';
export const REMOVE_COMMAND = 'map/REMOVE_COMMAND';

export default function getActions(dispatch) {
    return {
        addCommand: (name, params) => dispatch({
            type: ADD_COMMAND, name, params
        }),
        changeView: (center, zoom, rotation, resolution) => dispatch({
            type: CHANGE_VIEW, center, zoom, rotation, resolution
        }),
        initProject: (mapProject) => dispatch({
            type: INIT_PROJECT, mapProject
        }),
        setLayerVisibility: (id, visibility) => dispatch({
            type: SET_LAYER_VISIBILITY, id, visibility
        }),
        removeCommand: (id) => dispatch({
            type: REMOVE_COMMAND, id
        }),
        reset: () => dispatch({
            type: RESET
        })
    };
}

function* workChangeView(options, action) {
    // nop;
}

export function* watchChangeView(options) {
    yield takeEvery(CHANGE_VIEW, workChangeView, options);
}

function* workChangeLayerVisibility(options, action) {
    // nop;
}

export function* watchChangeLayerVisibility(options) {
    yield takeEvery(SET_LAYER_VISIBILITY, workChangeLayerVisibility, options);
}
